import { Payload, Types } from 'states/dux/layout/types'
import { Action } from 'states/types'
import { getSavedLanguage } from 'utils/common'

const initialState: Payload = {
  drawerIsOpen: true,
  language: getSavedLanguage()
}

const reducer = (state = initialState, action: Action<Payload>): Payload => {
  const { type, payload } = action
  switch (type) {
    case Types.SET: {
      localStorage.setItem('nivos_language', JSON.stringify(payload.language))
      return payload
    }
    case Types.UPDATE: {
      const newState = { ...state, ...payload }
      localStorage.setItem('nivos_language', JSON.stringify(newState.language))
      return newState
    }
    default:
      return state
  }
}

export { reducer }

export default reducer
